import{morph}from"@theme/morph";import{Component}from"@theme/component";import{CartUpdateEvent,ThemeEvents}from"@theme/events";import{DialogComponent,DialogCloseEvent}from"@theme/dialog";import{mediaQueryLarge,isMobileBreakpoint,getIOSVersion}from"@theme/utilities";

// BXGX sync function
let isSyncingQuick = false;

async function syncBXGXFromQuickAdd() {
  if (isSyncingQuick) return;
  isSyncingQuick = true;

  const BXGX_OFFERS = [
    {
      variantId: 52382338842929,  // Cream of Coco Soap Pack of 3
      buy: 3,
      get: 3
    },
    // Naye offers yahan add karo:
    // { variantId: VARIANT_ID, buy: 1, get: 1 },
  ];

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    for (const offer of BXGX_OFFERS) {
      let paidQty = 0, freeQty = 0, freeLineKey = null;

      cart.items.forEach(item => {
        if (item.variant_id == offer.variantId) {
          if (item.properties && item.properties['_free_item'] === 'true') {
            freeQty = item.quantity;
            freeLineKey = item.key;
          } else {
            paidQty += item.quantity;
          }
        }
      });

      const neededFree = Math.floor(paidQty / offer.buy) * offer.get;

      if (neededFree > freeQty) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: offer.variantId,
              quantity: neededFree - freeQty,
              properties: { '_free_item': 'true', '🎁 Free Item': '✓' }
            }]
          })
        });
        isSyncingQuick = false;
        location.reload();
        return;
      } else if (neededFree < freeQty && freeLineKey) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: freeLineKey, quantity: neededFree })
        });
        isSyncingQuick = false;
        location.reload();
        return;
      }
    }
  } catch(e) {
    console.error('BXGX quick-add sync error:', e);
  }

  isSyncingQuick = false;
}

export class QuickAddComponent extends Component{#e=null;#t=new Map;get productPageUrl(){const e=this.closest("product-card"),t=e?.getProductCardLink();if(!t?.href)return"";const o=new URL(t.href);if(o.searchParams.has("variant"))return o.toString();const n=this.#o();return n&&o.searchParams.set("variant",n),o.toString()}#o(){const e=this.closest("product-card");return e?.getSelectedVariantId()||null}connectedCallback(){super.connectedCallback(),mediaQueryLarge.addEventListener("change",this.#n)}disconnectedCallback(){super.disconnectedCallback(),mediaQueryLarge.removeEventListener("change",this.#n),this.#e?.abort()}handleClick=async e=>{e.preventDefault();const t=this.productPageUrl;let o=this.#t.get(t);if(!o){const e=await this.fetchProductPage(t);if(e){const n=e.querySelector("[data-product-grid-content]");n&&(o=n.cloneNode(!0),this.#t.set(t,o))}}if(o){const e=o.cloneNode(!0);await this.updateQuickAddModal(e)}this.#a()};#r(e){this.toggleAttribute("stay-visible",!0),e.addEventListener(DialogCloseEvent.eventName,(()=>this.toggleAttribute("stay-visible",!1)),{once:!0})}#a=()=>{const e=document.getElementById("quick-add-dialog");e instanceof QuickAddDialog&&(this.#r(e),e.showDialog())};#n=()=>{const e=document.getElementById("quick-add-dialog");e instanceof QuickAddDialog&&e.closeDialog()};async fetchProductPage(e){if(!e)return null;this.#e?.abort(),this.#e=new AbortController;try{const t=await fetch(e,{signal:this.#e.signal});if(!t.ok)throw new Error(`Failed to fetch product page: HTTP error ${t.status}`);const o=await t.text();return(new DOMParser).parseFromString(o,"text/html")}catch(e){if("AbortError"===e.name)return null;throw e}finally{this.#e=null}}async updateQuickAddModal(e){const t=document.getElementById("quick-add-modal-content");if(e&&t){if(isMobileBreakpoint()){const t=e.querySelector(".product-details");if(!t)return;const o=e.querySelector("product-form-component"),n=e.querySelector("variant-picker"),a=e.querySelector("product-price"),r=document.createElement("a");if(r.textContent=this.dataset.productTitle||"",r.href=this.productPageUrl,!(o&&n&&a&&r))return;const i=document.createElement("div");i.classList.add("product-header"),i.appendChild(r),i.appendChild(a),e.appendChild(i),e.appendChild(n),e.appendChild(o),t.remove()}morph(t,e),this.#i(t)}}#i(e){const t=this.#o();if(!t)return;const o=e.querySelectorAll('input[type="radio"][data-variant-id]');for(const e of o)if(e instanceof HTMLInputElement&&e.dataset.variantId===t&&!e.checked){e.checked=!0,e.dispatchEvent(new Event("change",{bubbles:!0}));break}}}customElements.get("quick-add-component")||customElements.define("quick-add-component",QuickAddComponent);

class QuickAddDialog extends DialogComponent{#e=new AbortController;connectedCallback(){super.connectedCallback(),this.addEventListener(ThemeEvents.cartUpdate,this.handleCartUpdate,{signal:this.#e.signal}),this.addEventListener(ThemeEvents.variantUpdate,this.#d),this.addEventListener(DialogCloseEvent.eventName,this.#l)}disconnectedCallback(){super.disconnectedCallback(),this.#e.abort(),this.removeEventListener(DialogCloseEvent.eventName,this.#l)}handleCartUpdate=e=>{e.detail.data.didError||(this.closeDialog(),setTimeout(syncBXGXFromQuickAdd,1500))};#d=e=>{const t=e.detail.data.html?.querySelector(".view-product-title a"),o=this.querySelector(".view-product-title a"),n=this.querySelector(".product-header a");t&&(o&&(o.href=t.href),n&&(n.href=t.href))};#l=()=>{const e=getIOSVersion();!e||e.major>=17||16===e.major&&e.minor>=4||requestAnimationFrame((()=>{const e=document.querySelector("#ResultsList [product-grid-view]");if(e){const t=e.getBoundingClientRect().width;e.style.width=t-1+"px",requestAnimationFrame((()=>{e.style.width=""}))}}))}}customElements.get("quick-add-dialog")||customElements.define("quick-add-dialog",QuickAddDialog);